// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* (Your CSS exactly as you pasted it — unchanged) */

.admin-panel {
  min-height: 100vh;
  background: #f8f9fa;
}

.admin-header {
  background: white;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  margin-bottom: 2rem;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
}

.header-content h1 {
  color: #333;
  font-size: 1.8rem;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 1rem;
  color: #666;
}

.logout-btn {
  padding: 0.5rem 1rem;
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.logout-btn:hover {
  background: #c82333;
}

.admin-nav {
  display: flex;
  justify-content: center;
  gap: 1rem;
  padding: 0 2rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
}

.nav-btn {
  padding: 1rem 2rem;
  background: none;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.nav-btn:hover {
  border-color: #667eea;
  background: #f8f9fa;
}

.nav-btn.active {
  background: #667eea;
  color: white;
  border-color: #667eea;
}

.admin-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0;
  box-sizing: border-box;
}

.management-tab {
  animation: fadeIn 0.3s ease;
}

.management-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 2rem;
  padding: 0 2rem;
  box-sizing: border-box;
}

.management-card {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  box-sizing: border-box;
  width: 100%;
}

.management-card h2 {
  margin-bottom: 1.5rem;
  color: #333;
  border-bottom: 2px solid #667eea;
  padding-bottom: 0.5rem;
}

.management-form .form-group {
  margin-bottom: 1.5rem;
}

.management-form label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #333;
}

.management-form input {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #e1e5e9;
  border-radius: 6px;
  font-size: 1rem;
  box-sizing: border-box;
}

.management-form input:focus {
  outline: none;
  border-color: #667eea;
}

.submit-btn {
  width: 100%;
  padding: 0.75rem;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s ease;
  box-sizing: border-box;
}

.submit-btn:hover:not(:disabled) {
  background: #5a6fd8;
}

.submit-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.file-list {
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 6px;
  margin: 1rem 0;
  box-sizing: border-box;
}

.file-list h4 {
  margin: 0 0 0.5rem 0;
  color: #333;
}

.file-list ul {
  margin: 0;
  padding-left: 1.5rem;
}

.file-list li {
  margin-bottom: 0.25rem;
  color: #666;
}

.message {
  padding: 1rem;
  border-radius: 6px;
  text-align: center;
  margin-top: 1rem;
  box-sizing: border-box;
}

.message.success {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.message.error {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.warning-message {
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  padding: 12px;
  margin: 15px 0;
  font-size: 14px;
  box-sizing: border-box;
}

.warning-message ul {
  margin: 8px 0 0 0;
  padding-left: 20px;
}

.warning-message li {
  margin-bottom: 4px;
}

.delete-btn {
  background-color: #dc3545 !important;
}

.delete-btn:hover:not(:disabled) {
  background-color: #c82333 !important;
}

.delete-btn:disabled {
  background-color: #6c757d !important;
  cursor: not-allowed;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.three-card-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 2rem;
  padding: 0 2rem;
  box-sizing: border-box;
}

.single-card-container {
  padding: 0 2rem;
  margin-bottom: 2rem;
  box-sizing: border-box;
}

.single-card {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  box-sizing: border-box;
  width: 100%;
}

@media (max-width: 1024px) {
  .three-card-grid {
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    padding: 0 1rem;
  }
}

@media (max-width: 768px) {
  .management-grid {
    grid-template-columns: 1fr;
    padding: 0 1rem;
    gap: 1rem;
  }
  
  .three-card-grid {
    grid-template-columns: 1fr;
    padding: 0 1rem;
    gap: 1rem;
  }
  
  .single-card-container {
    padding: 0 1rem;
  }
  
  .management-card,
  .single-card {
    padding: 1.5rem;
  }
  
  .admin-nav {
    padding: 0 1rem 1rem;
    flex-wrap: wrap;
  }
  
  .nav-btn {
    padding: 0.75rem 1.5rem;
    font-size: 0.9rem;
  }
  
  .header-content {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .management-card,
  .single-card {
    padding: 1rem;
  }
  
  .management-grid,
  .three-card-grid {
    gap: 0.75rem;
  }
}

.audio-count-info {
  margin-bottom: 20px;
  padding: 10px 15px;
  background-color: #f8f9fa;
  border-left: 4px solid #007bff;
  border-radius: 4px;
}

.count-text {
  font-size: 16px;
  font-weight: 600;
  color: #495057;
}

.advanced-filter-tab {
  padding: 20px;
}

.section-label {
  display: block;
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
}

.filter-selection {
  margin-bottom: 30px;
}

.filter-type-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px;
  margin-top: 10px;
}

.filter-type-btn {
  padding: 12px 20px;
  border: 2px solid #ddd;
  background: white;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.filter-type-btn:hover {
  border-color: #4a90e2;
  background: #f0f7ff;
}

.filter-type-btn.active {
  border-color: #4a90e2;
  background: #4a90e2;
  color: white;
}

.filter-container {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 25px;
  margin-bottom: 30px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.filter-title {
  margin-top: 0;
  margin-bottom: 20px;
  color: #333;
  border-bottom: 2px solid #f0f0f0;
  padding-bottom: 10px;
}

.filter-section {
  padding: 20px 0;
}

.filter-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}

.filter-group {
  margin-bottom: 20px;
}

.filter-label {
  display: block;
  font-weight: 500;
  margin-bottom: 8px;
  color: #555;
}

.filter-select,
.filter-input,
.filter-textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.3s ease;
}

.filter-select:focus,
.filter-input:focus,
.filter-textarea:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
}

.filter-textarea {
  resize: vertical;
  min-height: 80px;
  font-family: inherit;
}

.filter-hint {
  font-size: 12px;
  color: #666;
  margin-top: 5px;
  font-style: italic;
}

.filter-btn {
  background: #4a90e2;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s ease;
  font-size: 14px;
}

.filter-btn:hover:not(:disabled) {
  background: #357ae8;
}

.filter-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.results-container {
  margin-top: 30px;
}

.results-container h3 {
  margin-bottom: 15px;
  color: #333;
}

.results-table-container {
  overflow-x: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: white;
}

.results-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 800px;
}

.results-table th {
  background: #f8f9fa;
  padding: 12px 15px;
  text-align: left;
  font-weight: 600;
  color: #333;
  border-bottom: 2px solid #e0e0e0;
}

.results-table td {
  padding: 10px 15px;
  border-bottom: 1px solid #eee;
  vertical-align: top;
}

.results-table tr:hover {
  background-color: #f8f9fa;
}

.results-table tr:last-child td {
  border-bottom: none;
}

.message {
  padding: 12px 20px;
  border-radius: 6px;
  margin: 15px 0;
  font-weight: 500;
}

.message.success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.message.error {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

@media (max-width: 768px) {
  .filter-type-grid {
    grid-template-columns: 1fr;
  }
  
  .filter-grid {
    grid-template-columns: 1fr;
  }
  
  .advanced-filter-tab {
    padding: 10px;
  }
  
  .filter-container {
    padding: 15px;
  }
}


.increment-note {
  margin-top: 12px;
  padding: 10px 12px;
  background: #f8f9fa;
  border-left: 4px solid #4a90e2;
  border-radius: 6px;
  color: #495057;
  font-size: 13px;
}

.increment-summary {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 20px;
  font-size: 14px;
  color: #333;
}

@media (max-width: 768px) {
  .increment-summary {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AdminPage.css"],"names":[],"mappings":"AAAA,oDAAoD;;AAEpD;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE;IACE,8BAA8B;IAC9B,SAAS;IACT,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,eAAe;IACf,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,eAAe;IACf,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;;EAEA;;IAEE,YAAY;EACd;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;;AAGA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* (Your CSS exactly as you pasted it — unchanged) */\n\n.admin-panel {\n  min-height: 100vh;\n  background: #f8f9fa;\n}\n\n.admin-header {\n  background: white;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  margin-bottom: 2rem;\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  box-sizing: border-box;\n}\n\n.header-content h1 {\n  color: #333;\n  font-size: 1.8rem;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  color: #666;\n}\n\n.logout-btn {\n  padding: 0.5rem 1rem;\n  background: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.logout-btn:hover {\n  background: #c82333;\n}\n\n.admin-nav {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  padding: 0 2rem 1rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  box-sizing: border-box;\n}\n\n.nav-btn {\n  padding: 1rem 2rem;\n  background: none;\n  border: 2px solid #e1e5e9;\n  border-radius: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n\n.nav-btn:hover {\n  border-color: #667eea;\n  background: #f8f9fa;\n}\n\n.nav-btn.active {\n  background: #667eea;\n  color: white;\n  border-color: #667eea;\n}\n\n.admin-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.management-tab {\n  animation: fadeIn 0.3s ease;\n}\n\n.management-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n  padding: 0 2rem;\n  box-sizing: border-box;\n}\n\n.management-card {\n  background: white;\n  padding: 2rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.management-card h2 {\n  margin-bottom: 1.5rem;\n  color: #333;\n  border-bottom: 2px solid #667eea;\n  padding-bottom: 0.5rem;\n}\n\n.management-form .form-group {\n  margin-bottom: 1.5rem;\n}\n\n.management-form label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.management-form input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 2px solid #e1e5e9;\n  border-radius: 6px;\n  font-size: 1rem;\n  box-sizing: border-box;\n}\n\n.management-form input:focus {\n  outline: none;\n  border-color: #667eea;\n}\n\n.submit-btn {\n  width: 100%;\n  padding: 0.75rem;\n  background: #667eea;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background 0.3s ease;\n  box-sizing: border-box;\n}\n\n.submit-btn:hover:not(:disabled) {\n  background: #5a6fd8;\n}\n\n.submit-btn:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.file-list {\n  background: #f8f9fa;\n  padding: 1rem;\n  border-radius: 6px;\n  margin: 1rem 0;\n  box-sizing: border-box;\n}\n\n.file-list h4 {\n  margin: 0 0 0.5rem 0;\n  color: #333;\n}\n\n.file-list ul {\n  margin: 0;\n  padding-left: 1.5rem;\n}\n\n.file-list li {\n  margin-bottom: 0.25rem;\n  color: #666;\n}\n\n.message {\n  padding: 1rem;\n  border-radius: 6px;\n  text-align: center;\n  margin-top: 1rem;\n  box-sizing: border-box;\n}\n\n.message.success {\n  background: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.message.error {\n  background: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.warning-message {\n  background-color: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 4px;\n  padding: 12px;\n  margin: 15px 0;\n  font-size: 14px;\n  box-sizing: border-box;\n}\n\n.warning-message ul {\n  margin: 8px 0 0 0;\n  padding-left: 20px;\n}\n\n.warning-message li {\n  margin-bottom: 4px;\n}\n\n.delete-btn {\n  background-color: #dc3545 !important;\n}\n\n.delete-btn:hover:not(:disabled) {\n  background-color: #c82333 !important;\n}\n\n.delete-btn:disabled {\n  background-color: #6c757d !important;\n  cursor: not-allowed;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.three-card-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n  padding: 0 2rem;\n  box-sizing: border-box;\n}\n\n.single-card-container {\n  padding: 0 2rem;\n  margin-bottom: 2rem;\n  box-sizing: border-box;\n}\n\n.single-card {\n  background: white;\n  padding: 2rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  box-sizing: border-box;\n  width: 100%;\n}\n\n@media (max-width: 1024px) {\n  .three-card-grid {\n    grid-template-columns: 1fr 1fr;\n    gap: 1rem;\n    padding: 0 1rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .management-grid {\n    grid-template-columns: 1fr;\n    padding: 0 1rem;\n    gap: 1rem;\n  }\n  \n  .three-card-grid {\n    grid-template-columns: 1fr;\n    padding: 0 1rem;\n    gap: 1rem;\n  }\n  \n  .single-card-container {\n    padding: 0 1rem;\n  }\n  \n  .management-card,\n  .single-card {\n    padding: 1.5rem;\n  }\n  \n  .admin-nav {\n    padding: 0 1rem 1rem;\n    flex-wrap: wrap;\n  }\n  \n  .nav-btn {\n    padding: 0.75rem 1.5rem;\n    font-size: 0.9rem;\n  }\n  \n  .header-content {\n    padding: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .management-card,\n  .single-card {\n    padding: 1rem;\n  }\n  \n  .management-grid,\n  .three-card-grid {\n    gap: 0.75rem;\n  }\n}\n\n.audio-count-info {\n  margin-bottom: 20px;\n  padding: 10px 15px;\n  background-color: #f8f9fa;\n  border-left: 4px solid #007bff;\n  border-radius: 4px;\n}\n\n.count-text {\n  font-size: 16px;\n  font-weight: 600;\n  color: #495057;\n}\n\n.advanced-filter-tab {\n  padding: 20px;\n}\n\n.section-label {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 10px;\n  color: #333;\n}\n\n.filter-selection {\n  margin-bottom: 30px;\n}\n\n.filter-type-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.filter-type-btn {\n  padding: 12px 20px;\n  border: 2px solid #ddd;\n  background: white;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.filter-type-btn:hover {\n  border-color: #4a90e2;\n  background: #f0f7ff;\n}\n\n.filter-type-btn.active {\n  border-color: #4a90e2;\n  background: #4a90e2;\n  color: white;\n}\n\n.filter-container {\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 10px;\n  padding: 25px;\n  margin-bottom: 30px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n.filter-title {\n  margin-top: 0;\n  margin-bottom: 20px;\n  color: #333;\n  border-bottom: 2px solid #f0f0f0;\n  padding-bottom: 10px;\n}\n\n.filter-section {\n  padding: 20px 0;\n}\n\n.filter-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.filter-group {\n  margin-bottom: 20px;\n}\n\n.filter-label {\n  display: block;\n  font-weight: 500;\n  margin-bottom: 8px;\n  color: #555;\n}\n\n.filter-select,\n.filter-input,\n.filter-textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: border-color 0.3s ease;\n}\n\n.filter-select:focus,\n.filter-input:focus,\n.filter-textarea:focus {\n  outline: none;\n  border-color: #4a90e2;\n  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);\n}\n\n.filter-textarea {\n  resize: vertical;\n  min-height: 80px;\n  font-family: inherit;\n}\n\n.filter-hint {\n  font-size: 12px;\n  color: #666;\n  margin-top: 5px;\n  font-style: italic;\n}\n\n.filter-btn {\n  background: #4a90e2;\n  color: white;\n  border: none;\n  padding: 12px 30px;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.3s ease;\n  font-size: 14px;\n}\n\n.filter-btn:hover:not(:disabled) {\n  background: #357ae8;\n}\n\n.filter-btn:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.results-container {\n  margin-top: 30px;\n}\n\n.results-container h3 {\n  margin-bottom: 15px;\n  color: #333;\n}\n\n.results-table-container {\n  overflow-x: auto;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  background: white;\n}\n\n.results-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 800px;\n}\n\n.results-table th {\n  background: #f8f9fa;\n  padding: 12px 15px;\n  text-align: left;\n  font-weight: 600;\n  color: #333;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n.results-table td {\n  padding: 10px 15px;\n  border-bottom: 1px solid #eee;\n  vertical-align: top;\n}\n\n.results-table tr:hover {\n  background-color: #f8f9fa;\n}\n\n.results-table tr:last-child td {\n  border-bottom: none;\n}\n\n.message {\n  padding: 12px 20px;\n  border-radius: 6px;\n  margin: 15px 0;\n  font-weight: 500;\n}\n\n.message.success {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.message.error {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n@media (max-width: 768px) {\n  .filter-type-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .filter-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .advanced-filter-tab {\n    padding: 10px;\n  }\n  \n  .filter-container {\n    padding: 15px;\n  }\n}\n\n\n.increment-note {\n  margin-top: 12px;\n  padding: 10px 12px;\n  background: #f8f9fa;\n  border-left: 4px solid #4a90e2;\n  border-radius: 6px;\n  color: #495057;\n  font-size: 13px;\n}\n\n.increment-summary {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px 20px;\n  font-size: 14px;\n  color: #333;\n}\n\n@media (max-width: 768px) {\n  .increment-summary {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
